<div class="row p-4">
  <p>Induction component</p>
</div>

